<script>
	import formBase from '@_system/components/base/form.vue'
	import proofbillbox from './box/proofbillbox.vue'
	import staticIndex from './static/index.vue'
	import importTable from '@_system/components/import/index.vue'
	export default {
		extends: formBase,
		name: 'reconciliationbillForm',
		props: {

		},
		render(h) {
			this.$slots.plug = [ 	
				<proofbillbox ref="proofbillbox" supplierwlnid = {this.supplierwlnid} billtime = {this.billtime} onSubmit = {this.proofbillboxSubmit} />, 
				<static-index ref="staticIndex" currentdetail = {this.currentdetail} />, 
				<importTable ref="reconciliationbillImport" />
			]
			return formBase.render.call(this, h)
		},
		data() {
			return {

				tableaddhandle: null,
				supplierwlnid: null,
				billtime: null,
				currentdetail: []
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			static_reconciliationbill_detail() {
				let table = this.fApi.el('$son_reconciliationbill_detail')
				let fullData = table.getTableData().fullData
				console.log(fullData)
				this.currentdetail = fullData
				this.$refs.staticIndex.modal_show()
			},
			autocheck_reconciliationbill_detail() {

				//console.log(this.billtime)
				if (!this.id) {
					this.$message.error('账单不存在')
				}
				if (!this.fApi.getValue('supplierwlnid')) {
					this.$message.error('供应商不存在')
				}
				if (!this.billtime) {
					this.$message.error('账单日期不存在')
				}
				this.$confirm('选择核对方式', '提示', {
					confirmButtonText: '只核对当前入库单',
					cancelButtonText: '核对当前并补充新入库单',
					distinguishCancelAndClose:true,
					type: 'warning'
				}).then((e)=>{
					if(e=='confirm'){
						this.autocheck('current')
					}
				}).catch((e)=>{
					if(e=='cancel'){
						this.autocheck('total')
					}
					
				})
			},
			autocheck(type){
				let table = this.fApi.el('$son_reconciliationbill_detail')
				let fullData = table.getTableData().fullData
				this.loading = true
				this.$api.reconciliationbill.autocheck({
					type:type,
					billid: this.id,
					billtime: this.billtime,
					formbillcode: fullData.map((item) => {
						return {
							billcode:item.billcode,
							stockcode:item.stockcode,
							goodscode:item.goodscode,
						}
					}),
					supplierwlnid: this.fApi.getValue('supplierwlnid')
				}).then((res) => {
					this.loading = false
					let table = this.fApi.el('$son_reconciliationbill_detail')
					let fullData = table.getTableData().fullData
					//console.log(fullData)
					fullData.forEach((item) => {
						let obj = res.find((_item) => {
							return _item.billCode == item.billcode && _item.stockCode == item
								.stockcode && _item.skuCode == item.goodscode
						})
						// if(item.billcode == 'CD202503050136' && item.stockcode == 'CG202503050056'){
						// 	console.log(obj,123)
						// 	return
						// }
						if (obj) {
							item.stockcode = obj.stockCode
							item.storageid = obj.storageID
							item.storagename = obj.storageName
				
							if (obj.proofbillcode) {
								item.stockamount = obj.stock_sum ? parseFloat(obj.stock_sum).toFixed(4) : 0
								item.proofbillcode = obj.proofbillcode
								item.ischeck = 5
								item.mark = null
								if (obj.code) {
									item.ischeck = 6
									item.mark = '已存在对账单【' + obj.code + '】请确认是否重复对账'
								}
								if (obj.proofbillstatus == 4) {
									item.ischeck = 6
									item.mark = '万里牛结算单未审核'
								}
							} else {
								if (obj.stockCode) {
									item.stockamount = obj.stock_sum ? parseFloat(obj.stock_sum).toFixed(4) : 0
									item.mark = (obj.voucherstatus == 2) ? '财务未核对' : '质检未签章'
									if (obj.voucherstatus == 4) {
										item.mark = '等待自动结算【2分钟】，如长时间未结算或业务类型为【对私】请财务手动结算'
									}
				
								} else {
									item.mark = '未入库'
									if (item.status == 3) {
										item.mark = '订单已完成，未关联入/出库单【wms关闭或合并明细】'
										item.ischeck = 5
									}
									if (item.status == 4) {
										item.mark = '已关闭'
										item.ischeck = 5
									}
								}
							}
						}else{
							item.mark = '未匹配到结果请删除后手动添加'
						}
					})
				
					let insertdata = []
					res.forEach((item) => {
						let obj = fullData.find((_item) => {
							return item.billCode == _item.billcode && item.stockcode == _item
								.stockCode && item.skuCode == _item.goodscode
						})
						if (!obj && !item.code) {
							insertdata.push(item)
						}
					})
				
					insertdata = this.createTableData(insertdata)
					//console.log(insertdata)
					insertdata.forEach((item) => {
						if (item.proofbillcode) {
							item.mark = null
							item.ischeck = 5
						} else {
							if (item.stockcode) {
								item.mark = (item.voucherstatus == 2) ? '财务未核对' : '质检未签章'
								if (item.voucherstatus == 4) {
									item.mark = '等待自动结算【2分钟】，如长时间未结算或业务类型为【对私】请财务手动结算'
								}
							} else {
								item.mark = '未入库'
								if (item.status == 3) {
									item.mark = '订单已完成，未关联入/出库单'
									item.ischeck = 5
								}
								if (item.status == 4) {
									item.mark = '已关闭'
									item.ischeck = 5
								}
							}
						}
					})
					this.fApi.el('$son_reconciliationbill_detail').getGrid().insertAt(insertdata).then(() => {
						this.computeItemAmount()
						this.computeAmount()
					})
				
				}, () => {
					this.loading = false
				})
			},
			importcheck_reconciliationbill_detail() {
				this.$refs.reconciliationbillImport.importcomfig = () => {
					return new Promise((reslove) => {
						let obj = [{
							code: "billcode",
							require: true,
							title: "采购/采退订单",
						}, {
							code: "stockcode",
							require: true,
							title: "入库/出库单",
						}, {
							code: "goodscode",
							require: true,
							title: "商品编码",
						}, {
							code: "stockamount",
							require: false,
							title: "入库/出库小计",
						}]
						reslove(obj)
					})
				}

				this.$refs.reconciliationbillImport.importApi = () => {
					this.checkimportdata()
				}
				this.$refs.reconciliationbillImport.importpanel()
			},
			checkimportdata() {

				let table = this.fApi.el('$son_reconciliationbill_detail')
				let fullData = table.getTableData().fullData
				let importdata = this.$refs.reconciliationbillImport.importGetTableData()
				//console.log(importdata)
				let newdata = []
				importdata.forEach((item) => {
					let obj = fullData.find((_item) => {
						return _item.billcode == item['采购/采退订单'] && _item.stockcode == item['入库/出库单'] &&
							_item.goodscode == item['商品编码']
					})
					if (obj) {
						obj.ischeck = 5
					} else {
						newdata.push(item)
					}
				})
				let insertdata = []
				if (newdata.length) {
					this.$refs.reconciliationbillImport.importLoading = true

					this.$api.reconciliationbill.getunsettlementbill(this.fApi.getValue('supplierwlnid'), {
						billtime: this.fApi.getValue('billtime'),
						mode: 'box',
						index: 0,
					}).then((res) => {
						this.$refs.reconciliationbillImport.importLoading = false
						//console.log(res)
						newdata.forEach((item) => {
							let obj = res.list.find((_item) => {
								return _item.billCode == item['采购/采退订单'] && _item.stockCode ==
									item['入库/出库单'] && _item.skuCode == item['商品编码']
							})
							if (obj) {
								insertdata.push(obj)
							}
						})
						insertdata = this.createTableData(insertdata)
						insertdata.forEach((item) => {
							item.ischeck = 5
						})

						this.fApi.el('$son_reconciliationbill_detail').getGrid().insertAt(insertdata).then(() => {
							this.computeItemAmount()
							this.computeAmount()
						})
						this.$refs.reconciliationbillImport.importNoticeShow = false
					}, () => {
						this.$refs.reconciliationbillImport.importLoading = false
					})
				}



			},


			// beforeSubmit(formData, next) {
			// 	let table = this.fApi.el('$son_reconciliationbill_detail')
			// 	let fullData = table.getTableData().fullData
			// 	let audit = 1
			// 	fullData.forEach((item) => {
			// 		if(item.status != 4 && item.ischeck == 0){
			// 			audit = 0
			// 		}
			// 	})
			// 	next()

			// },
			proofbillboxSubmit(e) {
				if (this.tableaddhandle) {
					let data = this.createTableData(e.data)
					data = this.$Lodash.orderBy(data, ['status', 'ischeck', 'billtype'], ['asc', 'desc', 'desc'])
					//console.log(data)
					this.tableaddhandle.obj = data
					this.tableaddhandle.next()
					this.$nextTick(() => {
						this.computeItemAmount()
						this.computeAmount()
					})
				}
			},
			createTableData(obj) {
				let data = []
				obj.forEach((item) => {
					data.push({
						biztime: parseInt(item.bizTime),
						billcode: item.billCode,
						detailID: item.detailID,
						stockDetailID: item.stockDetailID,
						stockcode: item.stockCode,
						storageid: item.storageID,
						storagename: item.storageName,
						goodscode: item.skuCode,
						goodsname: item.goodsName,
						goodsmodel: item.skuName,
						proofbillcode: item.proofbillcode,
						price: item.price ? parseFloat(item.price) : 0,
						size: item.size ? parseFloat(item.size) : 0,
						purchaseamount: item.sum ? parseFloat(item.sum) : 0,
						stockamount: item.stock_sum ? parseFloat(item.stock_sum) : 0,
						status: item.status,
						diffamount: item.remain ? parseFloat(item.remain) : 0,
						billtype: item.billType,
						discount: 0,
						mark: item.mark ? item.mark : null,
						ischeck: 6
					})
				})
				console.log(data,34444)
				return data
			},
			afterGet(data) {
				this.billtime = data.billtime / 1000
			},


			regestEvent(rule, fApi) {

				if (this.id == 0) {
					this.billtime = this.extra.billtime
					console.log(this.billtime)
					fApi.setValue('billtime', this.extra.billtime * 1000)
				}


				let $son_reconciliationbill_detail = this.fApi.el('$son_reconciliationbill_detail')
				$son_reconciliationbill_detail.reconciliationcheck = (row) => {
					if (row.status == 4) {
						this.$message.error('订单已关闭')
					} else {
						row.ischeck = row.ischeck == 5 ? 6 : 5
					}

				}
				// $son_reconciliationbill_detail.gridOptions.cellStyle = ({
				// 	row
				// }) => {
				// 	if (row.ischeck == 5) {
				// 		return {
				// 			backgroundColor: 'rgb(225, 243, 216)',
				// 		}
				// 	}
				// 	if (row.status == 4) {
				// 		return {
				// 			backgroundColor: 'rgb(233, 233, 235)',
				// 		}
				// 	}
				// }
			},
			tableAdd(e) {
				this.supplierwlnid = this.fApi.getValue('supplierwlnid')
				if (this.supplierwlnid) {
					this.$refs.proofbillbox.initList()
					this.$refs.proofbillbox.box.alertBox()
				} else {
					this.$message.error('请选择供应商')
				}
				this.tableaddhandle = e

			},
			tablefieldChange(e) {
				//console.log(e)
				if (e.data.column.field == 'ischeck') {
					if (!e.data.row.stockcode) {
						e.data.row.ischeck = 6
						this.$message.error('未入库无法核对')
					}
				}
				this.computeItemAmount()
			},
			aftertabledelete() {
				this.computeItemAmount()
				this.computeAmount()
			},
			discountChange() {
				//this.computeItemAmount()
				this.computeAmount()
			},
			supplieramountChange() {
				this.computeAmount()
			},
			computeItemAmount() {
				let inamount = 0
				let outamount = 0
				let checkinamount = 0
				let checkoutamount = 0
				let table = this.fApi.el('$son_reconciliationbill_detail')
				let fullData = table.getTableData().fullData
				//console.log(fullData)
				fullData.forEach((item) => {
					if (/^CD/.test(item.billcode)) {
						inamount += (item.stockamount ? parseFloat(item.stockamount) : 0)
						if (item.ischeck == 5) {
							checkinamount += (item.stockamount ? parseFloat(item.stockamount) : 0)
						}
					}
					if (/^CTD/.test(item.billcode)) {
						outamount += (item.stockamount ? parseFloat(item.stockamount) : 0)
						if (item.ischeck == 5) {
							checkoutamount += (item.stockamount ? parseFloat(item.stockamount) : 0)
						}
					}
				})
				this.fApi.setValue('inamount', inamount)
				this.fApi.setValue('outamount', outamount)

				this.fApi.setValue('amount', inamount - outamount)
				this.fApi.setValue('checkamount', checkinamount - checkoutamount)
			},
			
			
			taxChange(){
				let tax = this.fApi.getValue('tax')
				tax = tax?parseFloat(tax):0
				let discountamount = this.fApi.getValue('discountamount')
				discountamount = discountamount?parseFloat(discountamount):0
				let point = tax/discountamount
				point = isNaN(tax/discountamount)?0:point
				this.fApi.setValue('taxpoint', (point * 100).toFixed(6))
				this.computeAmount()
			},
			
			computeAmount() {
				let amount = this.fApi.getValue('amount')
				let taxpoint = this.fApi.getValue('taxpoint')
				taxpoint = taxpoint?parseFloat(taxpoint):0
				amount = amount ? parseFloat(amount) : 0
				this.fApi.setValue('amount', amount)
				let discount = this.fApi.getValue('discount')
				discount = discount ? parseFloat(discount) : 0
				let discountamount = amount - discount
				discountamount = discountamount ? parseFloat(discountamount) : 0
				this.fApi.setValue('discountamount', discountamount)

				let supplieramount = this.fApi.getValue('supplieramount')
				supplieramount = supplieramount ? parseFloat(supplieramount) : 0
				this.fApi.setValue('diff', discountamount - supplieramount)					
				this.fApi.setValue('tax', (discountamount*taxpoint/100).toFixed(2))
				
				

			}
		},
		components: {
			proofbillbox,
			staticIndex
		}
	}
</script>